import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  AlertDialogCloseButton,
  useDisclosure,
  Button,
  Box,
  Text,
} from '@chakra-ui/react'
import { useRef } from 'react'
import { FaRegTrashAlt } from 'react-icons/fa'

export function ExcludeButton({ onClick }) {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const cancelRef = useRef()

  async function handleDeleteItem() {
    onClick()
    onClose()
  }

  return (
    <>
     <Box 
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexDir="column"
      onClick={onOpen}
      cursor={onClick ? 'pointer' : 'default'}
      >
      <Text fontSize="14px">
          Excluir
      </Text>
        <FaRegTrashAlt onClick={onOpen} size={30} color="#ff0000"/>
    </Box>

      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize='lg' fontWeight='bold'>
              Deletar item
            </AlertDialogHeader>

            <AlertDialogBody>
              Tem certeza que deseja deletar esse item? Essa ação é irreversível.
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose}>
                Cancelar
              </Button>
              <Button colorScheme='red' onClick={handleDeleteItem} ml={3}>
                Deletar
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  )
}